export default "__VITE_ASSET__Buje1EhM__"